import { Button, ButtonProps, useTheme } from '@mui/material'
import React from 'react'

interface ContainedButtonProps extends ButtonProps {
  customText?: string
}

export const ContainedButton: React.FC<ContainedButtonProps> = ({ children, ...props }) => {
  const theme = useTheme()
  const { customText, sx, ...rest } = props

  return (
    <Button
      {...rest}
      variant="contained"
      sx={{
        backgroundColor: theme.palette.button.default,
        borderRadius: 2,
        textTransform: 'none',
        ...sx,

        '&:hover': {
          backgroundColor: theme.palette.button.hover,
        },
        '&:active': {
          backgroundColor: theme.palette.button.pressed,
        },
      }}
    >
      {children}
    </Button>
  )
}
